import { render, staticRenderFns } from "./SpotView.vue?vue&type=template&id=50f792d0&lang=pug&"
import script from "./SpotView.vue?vue&type=script&lang=ts&"
export * from "./SpotView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports